import { SystemEntityCollections } from "../../shared/enums/shared-enums";
import { Person } from "../../types/person";
import { stringifyPersonName } from "../../hooks/logic/personLogic";

interface NodeEntity {
  published_id?: string;
  name?: any;
  name_attribute_pre?: string;
  name_primary?: string;
  name_attribute_post?: string;
}

const renderDisplayText = (
  entity: NodeEntity,
  entityCollection: string
): string => {
  const { name, published_id } = entity;
  const title =
    entityCollection === SystemEntityCollections.PERSON
      ? stringifyPersonName((entity as Partial<Person>).name_internal_evidence)
      : name || "";
  return title ? `${title} (${published_id})` : `${published_id}`;
};

export default renderDisplayText;
